import type {RecordRow} from 'src/features/record-grid/lib/types';
import type {Rec} from 'typings/portaro.be.types';

export const logbookReportsPageSize = 100;
export type LogbookReportPairingType = 'pair' | 'unpair';

export interface PairUnpairEventData {
    record: RecordRow;
    pairingType: LogbookReportPairingType;
}

export interface LogbookPairingBatchExportModalModel {
    projectRecord: Rec;
}